import { isNullOrUndefined } from 'util';
import { AppState } from '../reducers';

export const SESSION_STORAGE = sessionStorage;

export function getState(): AppState | undefined {
  const state = JSON.parse(SESSION_STORAGE.getItem('state'));

  return state || undefined;
}

export function setState(state: AppState): void {
  SESSION_STORAGE.setItem('state', JSON.stringify(state));
}

export function clearState(): void {
  SESSION_STORAGE.clear();
}

export function setSessionToken(token: string): void {
  localStorage.setItem('auth_token', token);
}
export function getSessionToken(): string | boolean {
  const authToken = localStorage.getItem('auth_token') as string;
  if (!isNullOrUndefined(authToken)) {
    return authToken.indexOf('Bearer') === -1 ? 'Bearer ' + authToken : undefined;
  } else {
    return false;
  }
}
